import clsx from "clsx"
import { IOutlinedText } from "."
import { FC, PropsWithChildren } from "react"
import styles from "./style.module.scss"

export const OutlinedTextV3: FC<PropsWithChildren<IOutlinedText>> = ({
  children,

  text,
  className,
  ...rest
}) => {
  return (
    <div className={clsx(styles.OutlinedText, className)} {...rest}>
      <div className={clsx(styles.OutlinedText_fakeText)}>{children}</div>
      <div
        data-text={text || children?.toString()}
        className={clsx(styles.OutlinedText_content)}
      >
        <div className={styles.OutlinedText_shadow}>{children}</div>
        <span>{children}</span>
      </div>
    </div>
  )
}
